import { Square, Volume2, VolumeX } from "lucide-react";
import { topStrength } from "../lib/narration";

export function TourCard({ institution, index, total, onStop, muted, onToggleMute }) {
  if (!institution) return null;
  const color = institution.color || "#B8912F";
  const top = topStrength(institution);

  return (
    <div className="tour-card" data-testid="tour-card" style={{ borderTop: `3px solid ${color}` }}>
      <div className="tour-card-head">
        <span className="tour-eyebrow" style={{ color }}>
          Guided Tour · {index + 1} / {total}
        </span>
        <div className="tour-actions">
          <button
            className="tour-mute"
            data-testid="tour-mute"
            onClick={onToggleMute}
            title={muted ? "Unmute narration" : "Mute narration"}
          >
            {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
          </button>
          <button className="tour-stop" data-testid="tour-stop" onClick={onStop}>
            <Square size={12} strokeWidth={2.4} fill="currentColor" />
            Stop
          </button>
        </div>
      </div>
      <h3 className="tour-name" style={{ color }} data-testid="tour-card-name">
        {institution.name}
      </h3>
      <p className="tour-blurb">
        Ranked <strong>#{institution.rank}</strong> with a composite resiliency of{" "}
        <strong>{institution.resiliency_rating.toFixed(2)}</strong>. Its standout
        strength is <strong>{top[0]}</strong> at <strong>{top[1].toFixed(1)}</strong>,
        anchoring its place among the most systemically resilient institutions in America.
      </p>
      <div className="tour-dots">
        {Array.from({ length: total }).map((_, i) => (
          <span
            key={i}
            className={`tour-dot${i === index ? " tour-dot-active" : ""}`}
            style={i === index ? { background: color } : undefined}
          />
        ))}
      </div>
    </div>
  );
}
